/// <amd-module name="Feed/Legacy/Actions/FeedSettings/PermanentDeleteFeedHandler" />
import { IFeedSettingsState } from "Feed/Legacy/Components/Settings/IFeedSettingsState";
import { getFeedClient, IFeedRestClient } from "Feed/Common/RestClient/Feed";

/**
 * User clicked on Permanently Delete feed button in Permanent Delete Feed Dialog
 */
export class PermanentDeleteFeedHandler {
    public static async handleAsync(state: IFeedSettingsState): Promise<void> {
        const feed = state.feed();
        const projectId = feed.project ? feed.project.id : null;

        const feedClient: IFeedRestClient = getFeedClient(state.pageContext);

        await feedClient.permanentDeleteFeed(feed.id, projectId);
        return;
    }
}
